import { render, staticRenderFns } from "./Course_stat_modal.vue?vue&type=template&id=0553dd23"
import script from "./Course_stat_modal.vue?vue&type=script&lang=js"
export * from "./Course_stat_modal.vue?vue&type=script&lang=js"
import style0 from "./Course_stat_modal.vue?vue&type=style&index=0&id=0553dd23&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports